import classNames from 'classnames';
import React, {ReactElement, useCallback, useId} from 'react';

import {proximityLabel} from '../../marketplace/util';
import Select from '../Select';
import SimpleTooltip from '../SimpleTooltip';

type Props = {
  proximity: number;
  disabled: boolean;
  onChange: (value: number) => void;
  asModal?: boolean;
  className?: string;
};

const ProximityDropdown = ({proximity, disabled, onChange, asModal, className}: Props): ReactElement => {
  const tooltipId = useId();

  const handleOptionSelected = useCallback(
    (value: number) => {
      onChange(value);
    },
    [onChange]
  );

  return (
    <div data-tooltip-id={tooltipId}>
      <Select
        floating
        disabled={disabled}
        buttonContent={disabled ? <span className={'text-gray-200'}>Proximity</span> : proximityLabel(proximity)}
        className={classNames(!disabled && proximity !== undefined && '[&>button]:border-primary-700', className)}
        asModal={asModal}
        options={[1, 5, 10, 50, 100, 200, -1].map(opt => ({value: opt, label: proximityLabel(opt)}))}
        onOptionSelected={handleOptionSelected}
        accessory={'radio'}
        selectedValues={[proximity]}
      />
      {disabled && <SimpleTooltip id={tooltipId}>Type a valid postcode or location first</SimpleTooltip>}
    </div>
  );
};

export default ProximityDropdown;
